var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIllustrationSolarActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4364_28293)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 21,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.7715,
    cy: 40.7735,
    rx: 14.7403,
    ry: 14.7403,
    fill: "url(#paint0_linear_4364_28293)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.493 34.2967C33.5815 34.0348 33.8282 33.8577 34.1053 33.8564H47.9025C48.1795 33.8577 48.4262 34.0348 48.5148 34.2967L51.3321 42.5134C51.4004 42.7108 51.3675 42.9296 51.2461 43.1004C51.1246 43.2699 50.9285 43.3711 50.7198 43.3711H41.6517V46.7387L43.7732 46.7399C44.1312 46.7399 44.4209 47.0296 44.4209 47.3877C44.4209 47.7457 44.1312 48.0354 43.7732 48.0354H38.2345C37.8765 48.0354 37.5868 47.7457 37.5868 47.3877C37.5868 47.0296 37.8765 46.7399 38.2345 46.7399H40.3561V43.3711H31.2879C31.0792 43.3711 30.8831 43.2699 30.7617 43.1004C30.6402 42.9296 30.6073 42.7107 30.6756 42.5134L33.493 34.2967ZM43.5162 42.0694L43.2708 39.9744H38.7367L38.4976 42.0757L43.5162 42.0694ZM43.1278 38.6789L42.9722 37.3063H39.0353L38.8797 38.6789H43.1278ZM48.1768 37.3063H44.2905L44.4334 38.6789H48.6437L48.1768 37.3063ZM39.2807 35.1531L39.1833 36.0108H42.8241L42.7267 35.1531H39.2807ZM37.7322 37.3063H33.8306L33.3575 38.6789H37.5677L37.7322 37.3063ZM34.2734 36.0108H37.8815L37.9789 35.1531L34.5683 35.1518L34.2734 36.0108ZM44.0284 35.1518L44.1258 36.0095L47.734 36.0108L47.4392 35.1531L44.0284 35.1518ZM49.1001 39.9745H44.566L44.8051 42.0758H49.8124L49.1001 39.9745ZM37.1943 42.0758L37.441 39.9745H32.9069L32.1883 42.0758H37.1943Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4364_28293",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.114844 0 0 0 0 0.222396 0 0 0 0 0.4375 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4364_28293"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4364_28293",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4364_28293",
    x1: 47.8876,
    y1: 33.6227,
    x2: 20.4277,
    y2: 68.6233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F76241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIllustrationSolarActive);
export default __webpack_public_path__ + "static/media/home_illustration_solar_active.82a7bb6d4ac9234c43e11c648990cc87.svg";
export { ForwardRef as ReactComponent };